import { isIconUrl } from './CategoryIcon';

/**
 * ProductImage
 *
 * Renders a product image from a media object, or — when no media is available —
 * the category icon as the placeholder. The icon may be an emoji/text or an
 * image URL; a URL renders as an <img>, otherwise the emoji renders as text in
 * the gradient placeholder box.
 *
 * Props:
 *   media: media object { cloudfront_path?, path?, ... } or null/undefined
 *   emoji: fallback category icon — emoji string or image URL (default '📦')
 *   alt: img alt text (default '')
 *   className: wrapper className
 *   imgClassName: className applied directly to <img>
 */
function ProductImage({ media, emoji = '📦', alt = '', className = '', imgClassName = '' }) {
  const src = media ? (media.cloudfront_path || media.path) : null;

  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        className={imgClassName || undefined}
        style={className ? undefined : { width: '100%', height: '100%', objectFit: 'cover' }}
      />
    );
  }

  // No product media — use the category icon. If it's an image URL, show it.
  if (isIconUrl(emoji)) {
    return (
      <img
        src={emoji}
        alt={alt}
        className={imgClassName || undefined}
        style={{ width: '60px', height: '60px', objectFit: 'contain' }}
      />
    );
  }

  return (
    <span
      className={className || undefined}
      style={{ fontSize: 'inherit' }}
      role="img"
      aria-label={alt || emoji}
    >
      {emoji}
    </span>
  );
}

export default ProductImage;
